import React from 'react'

import './compact-model-list-item.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    image: React.ReactNode
    headline: React.ReactNode
    children: React.ReactNode
    aside: React.ReactNode
  }
>

const CompactModelListItem = ({className, image, headline, children, aside, ...props}: Props) => (
  <div {...props} className={cn('CompactModelListItem', {}, className)}>
    <div className="CompactModelListItem__image">{image}</div>
    <div className="CompactModelListItem__content">
      <div className="CompactModelListItem__headline">{headline}</div>
      <div className="CompactModelListItem__children">{children}</div>
    </div>
    <div className="CompactModelListItem__aside">{aside}</div>
  </div>
)

export default CompactModelListItem
